module.exports = __webpack_public_path__ + "static/ritorno-white-03c7d711bda0de2d9123fa9004380cb8.svg";